/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2024, Zumper
 */
export const START_FETCHING_CANCELLATION = '@@nzr/Detail/START_FETCHING_CANCELLATION'
export const DONE_FETCHING_CANCELLATION = '@@nzr/Detail/DONE_FETCHING_CANCELLATION'
export const ERROR_FETCHING_CANCELLATION = '@@nzr/Detail/ERROR_FETCHING_CANCELLATION'
export const RECEIVE_CANCELLATION = '@@nzr/Detail/RECEIVE_CANCELLATION'
